"use client";

import moment from "moment";
import React from "react";
import { IoMdStar } from "react-icons/io";

const KeyInfo = ({ keyInfo }) => {
  return (
    <div className="m-4">
      <p className="font-bold text-2xl text-[#333333] mb-4">Key Information</p>
      <div className="flex flex-row gap-4">
        <div className="border border-solid border-[#E0E0E0] p-4 gap-4 rounded-lg flex flex-col w-[361px] h-fit">
          <p className="text-[#262626] font-bold text-base">Fund Overview</p>
          <div className="flex flex-row justify-between items-center w-full">
            <div className="basis-[50%] text-left">
              <p className="text-[#8B8B8B] font-medium text-xs">
                NAV: {moment(keyInfo?.fund_overview?.nav_date).format("LL")}
              </p>
              <p className="font-bold text-xs text-[#333333] mt-1">
                &#8377; {keyInfo?.fund_overview?.nav.toFixed(2)}
              </p>
            </div>
            <div className="basis-[50%] text-right">
              <p className="text-[#8B8B8B] font-medium text-xs">(VRO)Rating</p>
              <div className="bg-[#12AC21] inline-flex justify-center items-center py-0 px-1 rounded text-white">
                <p className="text-xs font-bold">
                  {keyInfo?.fund_overview?.vr_rating}
                </p>{" "}
                <IoMdStar className="w-[10px] h-[10px]" />
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <div className="basis-[50%] text-left">
              <p className="text-[#8B8B8B] font-medium text-xs">
                Min. Investment
              </p>
              <p className="font-bold text-xs text-[#333333] mt-1">
                &#8377; {keyInfo?.fund_overview?.min_investment}
              </p>
            </div>
            <div className="basis-[50%] text-right">
              <p className="text-[#8B8B8B] font-medium text-xs">Fund Size</p>
              <p className="font-bold text-xs text-[#333333] text-right mt-1">
                &#8377; {keyInfo?.fund_overview?.fund_size}
              </p>
            </div>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <div className="basis-[50%] text-left">
              <p className="text-[#8B8B8B] font-medium text-xs">
                Expense Ratio
              </p>
              <p className="font-bold text-xs text-[#333333] mt-1">
                {keyInfo?.fund_overview?.expense_ratio}%
              </p>
            </div>
            <div className="basis-[50%] text-right">
              <p className="text-[#8B8B8B] font-medium text-xs">Exit Load</p>
              <p className="font-bold text-xs text-[#333333] text-right mt-1">
                {keyInfo?.fund_overview?.exit_load_rate}%
              </p>
            </div>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            <div className="basis-[50%] text-left">
              <p className="text-[#8B8B8B] font-medium text-xs">Risk</p>
              <p className="font-bold text-xs text-[#333333] mt-1">
                {keyInfo?.fund_overview?.risk}
              </p>
            </div>
            <div className="basis-[50%] text-right">
              <p className="text-[#8B8B8B] font-medium text-xs">Benchmark</p>
              <p className="font-bold text-xs text-[#333333] text-right mt-1">
                {keyInfo?.fund_overview?.benchmark}
              </p>
            </div>
          </div>
          <div className="flex flex-row justify-between items-center w-full">
            {/* <div className="">
              <p className="text-[#8B8B8B] font-medium text-xs">Lock -in</p>
              <p className="font-bold text-xs text-[#333333]">
                {keyInfo?.fund_overview?.risk}
              </p>
            </div> */}
            <div className="basis-[50%] text-left">
              <p className="text-[#8B8B8B] font-medium text-xs">Age</p>
              <p className="font-bold text-xs text-[#333333] text-left overflow-hidden whitespace-nowrap text-ellipsis mt-1">
                {keyInfo?.fund_overview?.age}
              </p>
            </div>
          </div>
          {/* <div className="flex flex-row justify-between">
            <div className="">
              <p className="text-[#8B8B8B] font-medium text-xs">STCG</p>
              <p className="font-bold text-xs text-[#333333]">
                {DummyData.data.scheme.STCG} Tax on returns
              </p>
            </div>
            <div className="flex flex-col text-right">
              <p className="text-[#8B8B8B] font-medium text-xs">LTCG</p>
              <p className="font-bold text-xs text-[#333333] text-right overflow-hidden whitespace-nowrap text-ellipsis">
                {DummyData.data.scheme.LTCG} Tax on returns
              </p>
            </div>
          </div> */}
        </div>
        <div className="border border-solid border-[#E0E0E0] p-4 gap-4 rounded-lg flex flex-col w-[361px] h-fit">
          <p className="text-[#262626] font-bold text-base ">Fund manager</p>
          <p className="font-bold text-xs text-[#333333]">
            {keyInfo?.fund_manager}
          </p>
        </div>

        {/* <div className="border border-solid border-[#E0E0E0] p-4 gap-4 rounded-lg flex flex-col w-[361px] h-[333px] ">
          <p className="text-[#262626] font-bold text-base ">Fund manager</p>
          {fundmanagerDummy.map((data) => (
            <div key={data.name} className="flex flex-col gap-1 border-b">
              <p className="font-bold text-xs text-[#333333]">{data.name}</p>
              <p className="text-[#8B8B8B] font-medium text-xs">{data.date}</p>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default KeyInfo;
